<template src="./consulta-apontamentos.html"></template>
<style lang="less" src="./consulta-apontamentos.less"></style>

<script>
import moment from "moment";
export default {
  data: function() {
    return {
      headers: [
        {
          text: "Projeto",
          align: "left",
          sortable: false,
          value: "nome"
        },
        {
          text: "Consultor",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Atividade",
          align: "left",
          sortable: false,
          value: "sigla"
        },
        {
          text: "Setor",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Data",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Descrição",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Ínicio",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Fim",
          align: "left",
          sortable: false,
          value: "acoes"
        },
        {
          text: "Total",
          align: "left",
          sortable: false,
          value: "acoes"
        }
      ],
      model: {},
      loading: false,
      grid: null,
      usuarios: [{ id: null, nome: "(Todos)" }],
      projetos: [{ id: null, nome: "(Todos)" }],
      paginaAtual: 1,
      searchQuery: null
    };
  },
  methods: {
    getLista() {
      this.loading = true;
      this.model.dataDeInicio = this.model.dataDeInicio
        ? this.model.dataDeInicio
        : null;
      this.model.dataDeTermino = this.model.dataDeTermino
        ? this.model.dataDeTermino
        : null;
      this.model.projetoId = this.model.projetoId ? this.model.projetoId : null;
      this.model.usuarioId = this.model.usuarioId ? this.model.usuarioId : null;

      this.$http
        .get(
          "/apontamentos/consulta?dataDeInicio=" +
            this.model.dataDeInicio +
            "&dataDeTermino=" +
            this.model.dataDeTermino +
            (this.model.projetoId ? "&projetoId=" + this.model.projetoId : "") +
            (this.model.usuarioId ? "&usuarioId=" + this.model.usuarioId : "")
        )
        .then(result => {
          this.loading = false;
          this.grid = result.data;
          console.log(this.grid);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProjetos() {
      this.$http
        .get("/projetos")
        .then(result => {
          this.projetos = this.projetos.concat(result.data.lista);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUsuarios() {
      this.$http
        .get("/usuarios")
        .then(result => {
          this.usuarios = this.usuarios.concat(result.data.lista);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted: function() {
    this.getProjetos();
    this.getUsuarios();
    this.model.dataDeInicio = moment()
      .startOf("month")
      .format("DD/MM/YYYY");
    this.model.dataDeTermino = moment().format("DD/MM/YYYY");
    this.getLista();
  }
};
</script>
